import {
  COLOR_PRIMARY_MAIN,
  COLOR_YELLOW,
  COLOR_GREEN,
  COLOR_RED,
} from "shared/theme/colors";
import { AdminRole } from "./types";

export const AdminRoleLabels: Record<
  AdminRole,
  { label: string; color: string }
> = {
  [AdminRole.CSOperator]: { label: "CS Operator", color: COLOR_PRIMARY_MAIN },
  [AdminRole.Translator]: { label: "Translator", color: COLOR_YELLOW },
  [AdminRole.ContentAdmin]: { label: "Content Admin", color: COLOR_GREEN },
  [AdminRole.SuperAdmin]: { label: "Super Admin", color: COLOR_RED },
};
